import * as L from 'leaflet'
import type _ from '@geoman-io/leaflet-geoman-free'
import { LineString } from 'geojson'
import area from '@turf/area'
import length from '@turf/length'

/*
Calculate the length of a Polyline. Only LineStrings are supported, MutiLineString Polylines are not.
Distance returned is in meters.
*/
export const calculatePolylineLength = (layer: L.Polyline<LineString>) => {
  return length(layer.toGeoJSON(), { units: 'meters' })
}

/*
Calculate the area of a Polygon.
Area returned is in m2.
*/
export const calculatePolygonArea = (layer: L.Polygon) => {
  return area(layer.toGeoJSON().geometry)
}
